// extracted by mini-css-extract-plugin
export default {"avatar":"UserOnboardingProfileImageSlide_avatar__MDqmD","background":"UserOnboardingProfileImageSlide_background__8IhJH"};